import { SeasonYearsToFetch } from './seasonalChartConsts';

export const getTailingContract = (letters: string, year: string) => {
  let result = '';
  letters.split('').forEach((letter, index) => {
    if (index !== 0) {
      result += `${letter}${year}`;
    }
  });
  return result;
};

export const getTenorMonth = (letter: string): number | undefined => {
  switch (letter) {
    case 'F':
      return 0;
    case 'G':
      return 1;
    case 'H':
      return 2;
    case 'J':
      return 3;
    case 'K':
      return 4;
    case 'M':
      return 5;
    case 'N':
      return 6;
    case 'Q':
      return 7;
    case 'U':
      return 8;
    case 'V':
      return 9;
    case 'X':
      return 10;
    case 'Z':
      return 11;
    default:
      return undefined;
  }
};

export const isYearlyTenor = (tenor_code: string) => {
  return tenor_code.length === 2;
};
export const isQuarterlyTenor = (product_symbol: string, tenor_code: string) => {
  return tenor_code.length === 3 && product_symbol.endsWith('q') && !isNaN(Number(tenor_code));
};

export const generateAllHistoricSymbols = (product_symbol: string, tenor_code: string) => {
  const isYearly = isYearlyTenor(tenor_code);
  const isQuarterly = isQuarterlyTenor(product_symbol, tenor_code);
  let tenorCodeYear;
  if (isYearly || isQuarterly) {
    tenorCodeYear = Number(tenor_code);
  } else {
    tenorCodeYear = Number(tenor_code[1] + tenor_code[2]);
  }
  const tenorCodeLetter = tenor_code.replace(/[^a-z]/gi, '');

  return Array.from({ length: SeasonYearsToFetch }).map((_, index) => {
    const seasonalContractSymbol = generateSymbolForYear(product_symbol, tenor_code, tenorCodeYear, tenorCodeLetter, index);
    return { name: seasonalContractSymbol, shift: index };
  });
};

const generateSymbolForYear = (product_symbol: string, tenor_code: string, tenorCodeYear: number, tenorCodeLetter: string, index: number): string => {
  const isSimpleFormat = isSimpleTenorFormat(tenor_code, tenorCodeLetter);
  if (isSimpleFormat) {
    return generateSimpleFormatSymbol(product_symbol, tenorCodeYear, tenorCodeLetter, index);
  } else {
    return generateComplexFormatSymbol(product_symbol, tenor_code, index);
  }
};

const isSimpleTenorFormat = (tenor_code: string, tenorCodeLetter: string): boolean => {
  const hasNoLetterAndNoFourthChar = !tenorCodeLetter.length && !tenor_code[3];
  const hasLetterWithValidFormat =
    tenorCodeLetter.length &&
    (tenor_code.length === 3 || (tenor_code.length === 6 && Number(tenor_code[1] + tenor_code[2]) === Number(tenor_code[4] + tenor_code[5])));

  return Boolean(hasNoLetterAndNoFourthChar || hasLetterWithValidFormat);
};

const generateSimpleFormatSymbol = (product_symbol: string, tenorCodeYear: number, tenorCodeLetter: string, index: number): string => {
  const year = tenorCodeYear - index;
  const firstLetter = tenorCodeLetter[0] ?? '';
  const tailingContract = tenorCodeLetter.length > 1 ? getTailingContract(tenorCodeLetter, String(year)) : '';

  return `${product_symbol}${firstLetter}${year}${tailingContract}`;
};

const generateComplexFormatSymbol = (product_symbol: string, tenor_code: string, index: number): string => {
  const firstYear = Number(tenor_code[1] + tenor_code[2]) - index;
  const secondYear = Number(tenor_code[4] + tenor_code[5]) - index;

  return `${product_symbol}${tenor_code[0]}${firstYear}${tenor_code[3]}${secondYear}`;
};

export const getShiftedDate = (originalTimestamp: string, yearsToAdd: number) => {
  const date = new Date(originalTimestamp);

  const newYear = date.getUTCFullYear() + yearsToAdd;
  date.setUTCFullYear(newYear);

  return Math.floor(date.getTime() / 1000);
};
